<div *ngIf="!light" class="card vx-product-card h-100 shadow-sm">
  <div class="card-header row g-0 headerspace text-center">
    <div class="col-12 my-auto">
      <h2 class="h5 card-title text-center m-0 p-0"><a [routerLink]="data.link" [queryParams]="{ product: data.title }"
          queryParamsHandling="merge">{{ data.title }}</a></h2>
    </div>
  </div>
  <div class="card-img-top text-center"> <a [attr.aria-label]="'Read more about the ' + data.title" [routerLink]="data.link" [queryParams]="{ product: data.title }"
      queryParamsHandling="merge"><img class="img-fluid" [ngSrc]="data.imgsrc" [alt]="'VeEX ' + data.title" width="200" height="200" loading="lazy" /></a>
  </div>
  <p class="px-3 stickerplaceholder"><span id="{{ stickerid + index }}" [class]="tagClass" [innerHTML]="data.tag"></span></p>
  <div class="row subtitlespace h6 bluebackground g-0 card-header p-1">
    <div class="col-sm-12 my-auto">
      <p class="fw-bold m-0 p-0 card-title text-center" [innerHTML]="data.subtitle | translate"></p>
    </div>
  </div>
  <div class="card-body">
    <app-component-line-clamp row="3" class="mb-3">
      <div #content>
        <p class="card-text h-100" [innerHTML]="data.text1 | translate"></p>
      </div>
    </app-component-line-clamp>
  </div>
</div>

<div *ngIf="light" class="card vx-product-card h-100 shadow-sm">
  <div class="card-header row g-0 headerspace text-center">
    <div class="col-12 my-auto">
      <h2 class="h5 card-title text-center m-0 p-0"><a [routerLink]="data.link" [queryParams]="{ product: data.title }"
          queryParamsHandling="merge">{{ data.title }}</a></h2>
    </div>
  </div>
  <div class="card-img-top text-center"> <a [attr.aria-label]="'Read more about the ' + data.title" [routerLink]="data.link" [queryParams]="{ product: data.title }"
      queryParamsHandling="merge"><img class="img-fluid" [ngSrc]="data.imgsrc" [alt]="'VeEX ' + data.title" width="200" height="200" loading="lazy" /></a>
  </div>
  <p class="px-3 stickerplaceholder"><span id="{{ stickerid + index }}" [class]="tagClass" [innerHTML]="data.tag"></span></p>
  <div class="row subtitlespace h6 bluebackground g-0 card-header p-1">
    <div class="col-sm-12 my-auto">
      <p class="fw-bold m-0 p-0 card-title text-center" [innerHTML]="data.subtitle | translate"></p>
    </div>
  </div>
</div>